import * as React from 'react';
export const SuperMoonwalkGrowthx = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg viewBox="0 0 72 78" fill="none" {...props}>
    <path
      d="M63.29 22.262c0-7.405-6.004-13.408-13.41-13.408-7.404 0-13.407 6.003-13.407 13.408 0 7.405 6.003 13.408 13.408 13.408 7.405 0 13.408-6.003 13.408-13.408z"
      fill="#600CE8"
    />
    <path
      d="M19.281 52.842l14.154-14.154M11.023 75.522L43.57 42.975M6.123 51.38l24.4-24.39M10.852 33.588L37.075 7.364C44.314.126 56.384.458 64.035 8.11c7.652 7.651 7.984 19.721.746 26.96L26.954 72.897"
      stroke="#600CE8"
    />
    <path
      d="M5.155 64.958l-.952.476s-.395.206-.656.548c-.278.359-.449.916-.449.925l-.512 1.75-.52-1.75c-.045-.162-.216-.629-.45-.925-.25-.333-.646-.54-.655-.548L0 64.958l.96-.485s.396-.207.657-.539c.278-.368.449-.916.449-.925l.511-1.751.521 1.751c.045.162.216.629.45.925.26.332.655.539.655.539l.952.485zM17.187 10.104l-1.626.809s-.664.35-1.114.943c-.475.601-.763 1.562-.763 1.58l-.88 2.982-.889-2.982c-.08-.27-.368-1.068-.763-1.58-.431-.575-1.096-.925-1.114-.943l-1.643-.809 1.643-.826s.665-.35 1.114-.925c.476-.62.763-1.562.763-1.58l.88-2.982.89 2.982c.08.269.367 1.068.762 1.58.45.575 1.114.925 1.114.925l1.626.826zM67.29 60.632l-1.201.58s-.497.254-.826.682c-.355.436-.578 1.143-.578 1.152l-.672 2.183-.63-2.198c-.061-.198-.261-.785-.553-1.165-.31-.426-.8-.692-.81-.7l-1.196-.607 1.21-.597s.497-.255.825-.673c.356-.454.58-1.143.58-1.152l.67-2.184.631 2.198c.061.199.26.785.553 1.165.318.426.81.692.81.692l1.187.624z"
      fill="#600CE8"
    />
    <path
      d="M55.459 16.219a4.293 4.293 0 10-8.586 0 4.293 4.293 0 008.586 0z"
      fill="#fff"
    />
  </svg>
);
